// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__11cjV","logo":"style_logo__1dyOX"};